import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PageHeader from '../../components/page/PageHeader';
import { update_page_meta } from '../../actions/page/header';
import { connect } from 'react-redux';
import QRCodeGenerator from '../../components/QRCodeGenerator';
import PrintLabel from '../../components/PrintLabel';
import axios from 'axios';
import { JSON_CONTENT_FORM_CONFIG } from '../../actions/Config';
import { useSearchParams } from 'react-router-dom';
import PrintBundleLabel from '../../components/PrintBundleLabel';

const BundleList = ({ update_page_meta }) => {
    update_page_meta({
        title: "Bundle List",
        description: "List with QR codes of product bundles",
    });
    
    const [qrCodes, setQrCodes] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [fetching, setFetching] = useState(false);
    const [printingProgress, setPrintingProgress] = useState(false);
    const bottomElementRef = useRef();
    useEffect(() => {
        const fetchMore = async () => {
          if (page > totalPages || fetching) return;
          try {
            setFetching(true);
            const fetchUrl = new URL(`${process.env.REACT_APP_API_BASE_URL}/finished-goods/list-bundles/`);
            fetchUrl.searchParams.append('page', page.toString());
            fetchUrl.searchParams.append('page_size', pageSize.toString());
            const response = await axios.get(fetchUrl, JSON_CONTENT_FORM_CONFIG);
            if (response.status === 200) {
                setQrCodes((prevItems) => {
                    if (page === 1) {
                        return response.data.results;
                    } else {
                        return [...prevItems, ...response.data.results];
                    }
                });
                setTotalPages(response.data.num_pages);
                setPage(page + 1);
            }
          } catch (error) {
            console.error("Error fetching more bundles:", error);
          } finally {
            setFetching(false);
          }
        };
        const options = {
          root: null, // viewport
          rootMargin: "0px",
          threshold: 0.1, // When 10% of the element is visible, trigger the callback
        };
    
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            fetchMore();
          }
        }, options);
  
        const bottomElement = bottomElementRef.current;
    
        if (bottomElement) {
          observer.observe(bottomElement);
        }
    
        return () => {
          if (bottomElement) {
            observer.unobserve(bottomElement);
          }
        };
      }, [bottomElementRef, page, totalPages, fetching]);
    const printQR = async (e) => {
        if (printingProgress) return;
        setPrintingProgress(true);
        const button = e.currentTarget;
        const qrContainer = button.closest('tr');
        const bundleId = qrContainer.dataset.id;
        
        const qrCodeSrc = qrContainer.dataset.code;
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        // Set the content of the iframe to be your print preview HTML
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(`
            <html>
                <head>
                    <title>Print Preview</title>
                    <style>
                        @page {
                            width: 100mm;
                            height: 50mm;
                            margin: 0;
                            padding: 0;
                        }
                        body {
                            font-family: Arial, sans-serif;
                            margin: 0;
                            padding: 0;
                            display: flex;
                            justify-content: flex-start;
                            justify-content: center;
                            align-items: center;
                            width: 100vw;
                            height: 100vh;
                        }
                    </style>
                </head>
                <body>
                    <div id="print-content"></div>
                </body>
            </html>
        `);
        iframeDocument.close();

        iframe.onload = () => {
            const printContainer = iframeDocument.getElementById('print-content');
            ReactDOM.render(<PrintBundleLabel qrCodeSrc={qrCodeSrc} bundleId={bundleId} />, printContainer);
            const imagesAndCanvas = Array.from(printContainer.querySelectorAll('img, canvas'));

            const waitForCanvasLoad = (canvas) => {
                return new Promise((resolve, reject) => {
                    const context = canvas.getContext('2d', { willReadFrequently: true });
                    if (!context) {
                        reject('Canvas context unavailable');
                        return;
                    }
            
                    const checkLoad = () => {
                        
                        if (context.canvas.width > 0 && context.canvas.height > 0) {
                            resolve();
                        } else {
                            setTimeout(checkLoad, 100); // Check again after a short delay
                        }
                        
                    };
                    setTimeout(checkLoad, 500); // Giving an initial delay of 500ms to check whether the canvas is loaded
                });
            };
            
            const loadPromises = imagesAndCanvas.map((element) => {
                if (element.tagName === 'IMG' && !element.complete) {
                    return new Promise((resolve, reject) => {
                        element.addEventListener('load', () => {
                            resolve();
                        });
                    });
                } else if (element.tagName === 'CANVAS') {
                    return waitForCanvasLoad(element);
                } else {
                    return Promise.resolve(); // For other elements, resolve immediately
                }
            });
            
            Promise.all(loadPromises).then(() => {
                // All images and canvases are loaded
                iframe.contentWindow.print();
                // iframe.contentWindow.onafterprint = () => {
                //     document.body.removeChild(iframe);
                // };
            }).catch((error) => {
                console.error('Error loading images and canvases:', error);
            });
        };

        
        // const onFocus = () => {
        //     iframe.remove()
        //     window.removeEventListener("focus", onFocus)
        // }
        // window.addEventListener("focus", onFocus)
        setPrintingProgress(false);
    }
    
    
  return (
    <>
        <PageHeader title="Product Bundles" />
        <div className="row layout-top-spacing" id="cancel-row">
            
            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                <div className="widget-content widget-content-area br-6">
                    
                    
                    
                    <div className="table-responsive mb-4 mt-4">
                        <table id="zero-config" className="table table-hover" style={{width: "100%"}}>
                            <thead>
                                <tr>
                                    <th>QR Code</th>
                                    <th>Bundle ID</th>
                                    <th>Products in Bundle</th>
                                    <th className="no-content"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    qrCodes?.map((item) => {
                                        return (
                                            <tr key={item?.id} data-code={item?.code} data-id={item.id}>
                                                <td>
                                                    <span><QRCodeGenerator value={item?.code} size={64} /></span></td>
                                                <td>Bundle {item?.id}</td>
                                                <td>{item?.count} products</td>
                                                <td className="cursor-pointer">
                                                    <button className='btn btn-primary' onClick={printQR}>Print Bundle QR</button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                            <tfoot ref={bottomElementRef}></tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default connect(null, {update_page_meta}) (BundleList);